import { render, staticRenderFns } from "./SitesForCustomer.vue?vue&type=template&id=5148e9f9&scoped=true"
import script from "./SitesForCustomer.vue?vue&type=script&lang=js"
export * from "./SitesForCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5148e9f9",
  null
  
)

export default component.exports